"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationMySiteBenefits = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    viewBox: " 0 0 125 85",
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#E6EDFB",
      className: "fill-primary10",
      d: "M72.698 14.015c-8.069-.282-15.755-2.911-23.093-5.787C42.267 5.353 34.996 2.166 27.121.642c-5.066-.98-10.86-1.118-14.94 1.621-3.93 2.633-5.198 7.19-5.88 11.41-.513 3.182-.815 6.523.59 9.498.978 2.066 2.712 3.802 3.912 5.78 4.171 6.885 1.225 15.374-3.3 22.096-2.116 3.154-4.581 6.162-6.217 9.518-1.637 3.356-2.394 7.203-.963 10.627 1.42 3.395 4.802 5.943 8.466 7.736C16.23 82.57 25 83.613 33.552 84.203c18.93 1.307 37.96.74 56.94.174 7.024-.21 14.078-.422 20.988-1.518 3.837-.609 7.798-1.574 10.582-3.907 3.537-2.962 4.414-7.973 2.043-11.684-3.971-6.224-14.962-7.77-17.74-14.453-1.529-3.678.042-7.774 2.264-11.19 4.767-7.318 12.758-13.737 13.179-22.102.29-5.744-3.552-11.498-9.491-14.215-6.227-2.853-14.86-2.49-19.453 2.225-4.73 4.863-13.041 6.732-20.166 6.482z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C4D4F8",
      className: "fill-primary40",
      fillRule: "evenodd",
      d: "M23.947 34h77.107l-3.97 18.133H27.916L23.947 34z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#88A9F0",
      className: "fill-primary",
      fillRule: "evenodd",
      d: "M31.884 36.267h61.232l-3.151 19.266h-54.93l-3.151-19.266z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M34.791 40.578h10.87v16.655h-10.87V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M42.515 40.578h3.146v16.655h-3.146V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M36.508 40.578h1.716v16.655h-1.716V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M41.084 45.172h1.717v2.872h-1.717v-2.871zm0 9.19h1.717v2.871h-1.717v-2.871z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M34.791 43.45h10.87v1.722h-10.87V43.45zm0 4.594h10.87v1.723h-10.87v-1.723zm0 4.595h10.87v1.723h-10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M27.354 45.172h10.87v12.061h-10.87v-12.06z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M35.077 43.45h3.147v13.783h-3.147V43.45z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M29.07 45.172h1.43v12.061h-1.43v-12.06z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M33.647 49.767h1.716v2.872h-1.716v-2.872zm-6.293-1.723h10.87v1.723h-10.87v-1.723zm0 4.595h10.87v1.723h-10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M76.18 40.578h10.87v16.655H76.18V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M83.903 40.578h3.147v16.655h-3.147V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M77.896 40.578h1.716v16.655h-1.716V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M82.473 45.172h1.716v2.872h-1.716v-2.871zm0 9.19h1.716v2.871h-1.716v-2.871z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M76.18 43.45h10.87v1.722H76.18V43.45zm0 4.594h10.87v1.723H76.18v-1.723zm0 4.595h10.87v1.723H76.18v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M85.818 41.711h10.87v16.656h-10.87V41.71z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M93.541 41.711h3.147v16.656h-3.147V41.71z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M87.534 41.711h1.716v16.656h-1.716V41.71z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M92.111 46.306h1.716v2.871h-1.716v-2.871zm0 9.189h1.716v2.872h-1.716v-2.872zm-6.293-10.912h10.87v1.723h-10.87v-1.723zm0 4.594h10.87V50.9h-10.87v-1.723zm0 4.595h10.87v1.723h-10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M69.974 40.578h-10.87v16.655h10.87V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M62.25 40.578h-3.147v16.655h3.147V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M68.257 40.578h-1.716v16.655h1.716V40.578z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M63.68 45.172h-1.716v2.872h1.717v-2.871zm0 9.19h-1.716v2.871h1.717v-2.871z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M69.974 43.45h-10.87v1.722h10.87V43.45zm0 4.594h-10.87v1.723h10.87v-1.723zm0 4.595h-10.87v1.723h10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M77.411 45.172h-10.87v12.061h10.87v-12.06z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M69.688 43.45H66.54v13.783h3.147V43.45z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M75.695 45.172h-1.43v12.061h1.43v-12.06z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M71.118 49.767h-1.716v2.872h1.716v-2.872zm6.293-1.723h-10.87v1.723h10.87v-1.723zm0 4.595h-10.87v1.723h10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M54.666 40.011h-10.87v16.656h10.87V40.01z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M46.942 40.011h-3.147v16.656h3.147V40.01z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M52.95 40.011h-1.717v16.656h1.716V40.01z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M48.373 44.606h-1.717v2.871h1.717v-2.871zm0 9.189h-1.717v2.872h1.717v-2.872zm6.293-10.912h-10.87v1.723h10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M54.666 47.477h-10.87V49.2h10.87v-1.723zm0 4.595h-10.87v1.723h10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      d: "M62.103 45.173h-10.87v12.06h10.87v-12.06z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M54.38 43.45h-3.147v13.783h3.147V43.45z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFE168",
      d: "M60.387 45.173h-1.43v12.06h1.43v-12.06z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#F7B523",
      d: "M55.81 49.767h-1.716v2.872h1.716v-2.872zm6.293-1.723h-10.87v1.723h10.87v-1.723zm0 4.595h-10.87v1.723h10.87v-1.723z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C4D4F8",
      className: "fill-primary40",
      fillRule: "evenodd",
      d: "M23.947 34h77.107l-5.64-9.664a7.938 7.938 0 00-6.857-3.936H36.443a7.938 7.938 0 00-6.856 3.936L23.947 34z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#1657E2",
      className: "fill-primary",
      fillRule: "evenodd",
      d: "M37.554 20.4h11.339l-2.268 10.292H31.884l5.67-10.292zm38.553 0h11.34l5.67 10.292H78.374L76.107 20.4zm-22.111 0h17.009l2.267 10.292H51.728L53.996 20.4z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C4D4F8",
      className: "fill-primary40",
      d: "M101.054 48.733H23.946v36.834h77.108V48.733z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#1657E2",
      className: "fill-primary",
      d: "M46.625 53.267H29.05v27.766h17.576V53.267zm49.326 0H78.375v27.766h17.576V53.267zm-22.679 0H51.728v27.766h21.544V53.267z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#88A9F0",
      className: "fill-primary",
      fillRule: "evenodd",
      d: "M57.398 48.733h10.205V54.4a1.7 1.7 0 01-1.701 1.7h-6.804a1.7 1.7 0 01-1.7-1.7v-5.667zm0-18.041h10.205v1.7a1.7 1.7 0 01-1.701 1.7h-6.804a1.7 1.7 0 01-1.7-1.7v-1.7z",
      clipRule: "evenodd"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#C4D4F8",
      className: "fill-primary40",
      d: "M64.201 48.733h-3.402V56.1h3.402v-7.367z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#88A9F0",
      className: "fill-primary",
      d: "M98.502 54.683a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zM95.668 31.45a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zM75.824 54.683a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm0-23.233a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zM49.176 54.683a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm0-23.233a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zM26.498 54.683a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm2.835-23.233a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm69.169 32.3a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm-22.678 0a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm-26.648 0a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm-22.678 0a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm72.004 9.067a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm-22.678 0a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm-26.648 0a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm-22.678 0a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm72.004 9.066a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm-22.678 0a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834zm-26.648 0a1.417 1.417 0 10.001-2.834 1.417 1.417 0 000 2.834zm-22.678 0a1.417 1.417 0 100-2.834 1.417 1.417 0 000 2.834z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#1245B4",
      d: "M62.5 53.267a1.134 1.134 0 100-2.268 1.134 1.134 0 000 2.268z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#1245B4",
      d: "M63.067 51.567h-1.134V54.4h1.134v-2.833z"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FDD33F",
      fillRule: "evenodd",
      d: "M108.776 9.995c2.57-.113 4.251-.565 5.041-1.355.791-.79 1.24-2.719 1.348-5.784.137 3.011.628 4.94 1.473 5.784.845.844 2.441 1.296 4.79 1.355-2.395.137-3.991.605-4.79 1.404-.799.798-1.29 2.758-1.473 5.879-.03-3.052-.48-5.012-1.348-5.88-.868-.867-2.548-1.335-5.041-1.403zm-11.698 8.323c2.015-.089 3.333-.443 3.953-1.063.62-.62.972-2.13 1.056-4.534.108 2.36.492 3.872 1.155 4.534.662.663 1.914 1.017 3.756 1.063-1.878.107-3.13.474-3.756 1.1-.627.627-1.011 2.163-1.155 4.61-.023-2.393-.376-3.93-1.056-4.61-.681-.68-1.999-1.047-3.953-1.1zm11.065 9.994c2.015-.088 3.333-.443 3.953-1.062.62-.62.972-2.131 1.057-4.535.107 2.361.492 3.873 1.154 4.535.663.662 1.914 1.016 3.756 1.062-1.878.108-3.129.475-3.756 1.1-.626.627-1.011 2.164-1.154 4.61-.024-2.392-.377-3.929-1.057-4.61-.681-.68-1.998-1.046-3.953-1.1zM14.785 9.995c-2.57-.113-4.25-.565-5.042-1.355-.79-.79-1.24-2.719-1.347-5.784-.137 3.011-.628 4.94-1.473 5.784-.845.844-2.442 1.296-4.79 1.355 2.394.137 3.991.605 4.79 1.404.799.798 1.29 2.758 1.473 5.879.03-3.052.48-5.012 1.347-5.88.868-.867 2.549-1.335 5.042-1.403zm12.832 8.323c-2.015-.089-3.333-.443-3.953-1.063-.62-.62-.972-2.13-1.057-4.534-.107 2.36-.492 3.872-1.154 4.534-.663.663-1.915 1.017-3.756 1.063 1.878.107 3.13.474 3.756 1.1.626.627 1.011 2.163 1.154 4.61.024-2.393.377-3.93 1.057-4.61.68-.68 1.998-1.047 3.953-1.1zm-11.065 9.994c-2.015-.088-3.333-.443-3.953-1.062-.62-.62-.972-2.131-1.057-4.535-.107 2.361-.492 3.873-1.154 4.535-.663.662-1.915 1.016-3.756 1.062 1.877.108 3.13.475 3.756 1.1.626.627 1.011 2.164 1.154 4.61.024-2.392.376-3.929 1.057-4.61.68-.68 1.998-1.046 3.953-1.1z",
      clipRule: "evenodd"
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationMySiteBenefits')(IllustrationMySiteBenefits);